import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
enum VARIANTS {
  NORMAL = 'normal',
  BUTTON = 'button',
}
enum TOOLTIP_POSITION {
  AFTER = 'after',
  BEFORE = 'before',
  ABOVE = 'above',
  BELOW = 'below',
  LEFT = 'left',
  RIGHT = 'right'
}
@Component({
  selector: 'app-signal-icon',
  templateUrl: './signal-icon.component.html',
  styleUrls: ['./signal-icon.component.css']
})

export class SignalIconComponent implements OnInit {
  variants = VARIANTS;
  tooltipPositionEnum = TOOLTIP_POSITION;

  @Input() label: string;
  @Input() labelToolTip:string
  @Input() value: any;
  @Input() keysValues: IColorKeys[] ;
  @Input() clickable: boolean = false;
  @Input() variant: VARIANTS = this.variants.NORMAL;
  @Input() tooltipPosition: string = this.tooltipPositionEnum.ABOVE;
  @Output('on-click') onClickEvent: EventEmitter<any> = new EventEmitter();

  color: string ;
  constructor() { }
  ngOnInit() {
  
  }

  ngOnChanges(): void {
    this.keysValues.forEach(element => {
      if (element.value == this.value) {
        this.color = element.color;
        return false;
      }
    });
    
  }
  handleClick() {
    this.onClickEvent.emit();
  }

}

export interface IColorKeys {
  value : string,
  color : string
}
